import { z } from "zod";

/** Token pessoal para integrações (MCP). Ver docs/18-mcp-creative-os.md. */

export const VALIDADES_TOKEN_PESSOAL = [30, 90, 365] as const;

export const tokenPessoalSchema = z.object({
  id: z.string().uuid(),
  nome: z.string(),
  prefixo: z.string(),
  escopos: z.array(z.string()),
  criadoEm: z.string().datetime(),
  ultimoUsoEm: z.string().datetime().nullable(),
  expiraEm: z.string().datetime().nullable(),
  revogadoEm: z.string().datetime().nullable(),
});

export const listaTokensPessoaisSchema = z.object({
  itens: z.array(tokenPessoalSchema),
});

export const criarTokenPessoalSchema = z.object({
  nome: z.string().trim().min(2).max(60),
  /** Null = não expira. */
  validadeDias: z.number().int().min(1).max(365).nullable(),
});

export const tokenPessoalCriadoSchema = z.object({
  item: tokenPessoalSchema,
  /** Só na primeira resposta. Null em repetição idempotente. */
  token: z.string().nullable(),
});

export type TokenPessoalDto = z.infer<typeof tokenPessoalSchema>;
export type ListaTokensPessoaisDto = z.infer<typeof listaTokensPessoaisSchema>;
export type CriarTokenPessoalDto = z.infer<typeof criarTokenPessoalSchema>;
export type TokenPessoalCriadoDto = z.infer<typeof tokenPessoalCriadoSchema>;
